import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  getWelcomeMessage,
  setWelcomeMessage
} from "asos-site-chrome-store-presentation";

import IconButton from "../IconButton";
import { getContext } from "@src/client/context";
import withTranslation from "../translation";
import {
  trackPageInteraction,
  ANALYTICS_CONTEXT,
  ANALYTICS_INTERACTION_NAVIGATE,
  ANALYTICS_INTERACTION_CLOSE,
  ANALYTICS_INTERACTION_IMPRESSION
} from "@src/helpers/events";
import getAlternateUrls from "../../helpers/getAlternateUrls";

import styles from "./deferred.css";
const ANALYTICS_IMPRESSION_DELAY = 2000;
class WelcomeMessage extends Component {
  state = {};
  componentDidMount() {
    const hasWelcomeMessageBeenClosed = getWelcomeMessage();
    if (hasWelcomeMessageBeenClosed) {
      return;
    }

    return this.props.requestWelcomeMessage(
      this.props.platform,
      getAlternateUrls()
    );
  }
  setClosedState = () => {
    setWelcomeMessage(true);
    this.setState({
      isClosed: true
    });
  };
  handleCloseEvent = () => {
    trackPageInteraction({
      context: ANALYTICS_CONTEXT.welcomeMessage,
      interaction: ANALYTICS_INTERACTION_CLOSE
    });
    this.setClosedState();
  };
  navigate = (url, e) => {
    e.preventDefault();
    const { countryCode, siteId, storeCode } = this.props.country;
    const currentBrowseCountry = getContext().getBrowseCountry();
    const currentStoreCode = getContext().getStoreId();
    trackPageInteraction({
      context: ANALYTICS_CONTEXT.welcomeMessage,
      interaction: ANALYTICS_INTERACTION_NAVIGATE,
      properties: {
        current: {
          countryCode: currentBrowseCountry,
          siteId: this.props.siteId,
          storeCode: currentStoreCode
        },
        new: {
          countryCode,
          siteId,
          storeCode
        }
      }
    });
    this.setClosedState();
    window.location.assign(url);
  };
  render() {
    const { redirectUrl } = this.props;
    if (this.state.isClosed || !redirectUrl) {
      return null;
    }
    window.setTimeout(() => {
      trackPageInteraction({
        context: ANALYTICS_CONTEXT.welcomeMessage,
        interaction: ANALYTICS_INTERACTION_IMPRESSION
      });
    }, ANALYTICS_IMPRESSION_DELAY);

    const {
      text,
      formatTranslation,
      country: {
        imageUrl,
        countryCode: browseCountry,
        defaultCurrency: browseCurrency
      }
    } = this.props;
    const { url, label } = redirectUrl;

    const affid = getContext().getAffiliateId();

    if (affid) {
      url.query = { ...url.query, xaffid: affid };
    }

    url.query = {
      ...url.query,
      r: 1,
      ctaref: "welcome mat",
      browseCountry,
      browseCurrency
    };
    const fullUrl = url.toString();

    return (
      <div
        className={styles.container}
        role="region"
        aria-labelledby="welcomeMessageText"
        data-testid="welcome-message"
      >
        <div className={styles.wrapper}>
          <img
            src={imageUrl}
            alt=""
            className={styles.flag}
            data-testid="icon"
          />
          <div>
            <p className={styles.text} id="welcomeMessageText">
              {text}
            </p>
            <a
              onClick={this.navigate.bind(this, fullUrl)}
              className={styles.redirectLink}
              href={fullUrl}
              data-testid="welcome-message-link"
            >
              {label}
            </a>
          </div>
          <IconButton
            icon={styles.close}
            data-testid="close-button"
            onClick={this.handleCloseEvent}
            aria-label={formatTranslation("icon_close")}
          />
        </div>
      </div>
    );
  }
}

WelcomeMessage.propTypes = {
  requestWelcomeMessage: PropTypes.func,
  redirectUrl: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.object
  }),
  text: PropTypes.string,
  country: PropTypes.shape({
    name: PropTypes.string,
    imageUrl: PropTypes.string,
    countryCode: PropTypes.string,
    defaultCurrency: PropTypes.string,
    siteId: PropTypes.integer,
    storeCode: PropTypes.string
  }),
  closeLabel: PropTypes.string,
  platform: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired,
  siteId: PropTypes.number
};

export default withTranslation(WelcomeMessage);
